/**
 * Tiny dev-only logger.
 *
 * Console output is suppressed in production builds so we don't leak
 * debug info or spam the browser console for end-users.
 *
 * Replace this module with a real error tracker (e.g. Sentry) when wiring
 * one up — every call site already routes through these helpers, so the
 * swap is a one-file change.
 *
 * The console.* calls below are intentional — this file is the abstraction.
 */
/* eslint-disable no-console */
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const logInfo = (...args) => {
  if (isDev) console.log(...args);
};
